import * as React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import KeyboardArrowUpRoundedIcon from "@mui/icons-material/KeyboardArrowUpRounded";
// import PolicyRoundedIcon from "@mui/icons-material/PolicyRounded";
// import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";

import { BRAND, CONTACT, UI } from "../config/site";
import NAV_SECTIONS from "../content/navigation";
import { headers } from "../content/meta";

export default function Footer() {
  const year = new Date().getFullYear();
  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const offset = window.innerWidth >= 900 ? UI.toolbar.md : UI.toolbar.xs;
    const top = el.getBoundingClientRect().top + window.scrollY - offset;
    window.scrollTo({ top, behavior: "smooth" });
  };
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <Box component="footer" sx={{ mt: { xs: 6, md: 10 } }}>
      {/* CTA من meta.footerCta */}
      <Box
        sx={{
          bgcolor: "secondary.main",
          color: "secondary.contrastText",
          py: { xs: 3, md: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            useFlexGap
            spacing={2}
          >
            <Stack spacing={0.5}>
              <Typography
                sx={{ fontWeight: 900, fontSize: { xs: 18, md: 20 } }}
              >
                {headers.footerCta.title}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {headers.footerCta.subtitle}
              </Typography>
            </Stack>
            <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
              <Button
                variant="contained"
                color="success"
                onClick={() => scrollToId("pricing")}
                sx={{ fontWeight: 800 }}
              >
                {headers.footerCta.primary}
              </Button>
              <Button
                variant="outlined"
                color="inherit"
                startIcon={<WhatsAppIcon />}
                href={`https://wa.me/${CONTACT.whatsapp}`}
                target="_blank"
                rel="noopener"
                sx={{ fontWeight: 800, borderColor: "rgba(255,255,255,.85)" }}
              >
                {headers.footerCta.secondary}
              </Button>
            </Stack>
          </Stack>
        </Container>
      </Box>

      {/* المحتوى الرئيسي */}
      <Box
        sx={{
          bgcolor: "primary.main",
          color: "primary.contrastText",
          pt: { xs: 4, md: 6 },
          pb: { xs: 3, md: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={4}>
            <Grid size={{ xs: 12, md: 4 }}>
              <Stack spacing={1.25}>
                <Typography sx={{ fontWeight: 900, fontSize: 18 }}>
                  {BRAND.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ opacity: 0.9, lineHeight: 1.9 }}
                >
                  نظام محاسبي سحابي عربي متكامل لإدارة المبيعات والمشتريات
                  والمخزون ونقاط البيع، متوافق مع الفوترة الإلكترونية في
                  المملكة.
                </Typography>
                <IconButton
                  aria-label="العودة للأعلى"
                  onClick={scrollTop}
                  sx={{
                    color: "primary.contrastText",
                    border: "1px solid rgba(255,255,255,.3)",
                    alignSelf: "flex-start",
                  }}
                >
                  <KeyboardArrowUpRoundedIcon />
                </IconButton>
              </Stack>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography sx={{ fontWeight: 900, mb: 1 }}>
                روابط سريعة
              </Typography>
              <Stack spacing={0.75}>
                {NAV_SECTIONS.filter((s) => s.id !== "header").map((l) => (
                  <Link
                    key={l.id}
                    component="button"
                    onClick={() => scrollToId(l.id)}
                    underline="hover"
                    color="inherit"
                    sx={{ textAlign: "start", opacity: 0.9 }}
                  >
                    {l.label}
                  </Link>
                ))}
              </Stack>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Typography sx={{ fontWeight: 900, mb: 1 }}>تواصل</Typography>
              <Stack spacing={1}>
                <Stack direction="row" spacing={1} alignItems="center">
                  <WhatsAppIcon />
                  <Link
                    underline="hover"
                    color="inherit"
                    href={`https://wa.me/${CONTACT.whatsapp}`}
                    target="_blank"
                    rel="noopener"
                    sx={{ fontWeight: 800 }}
                  >
                    واتساب: +{CONTACT.whatsapp}
                  </Link>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <PhoneRoundedIcon />
                  <Link
                    underline="hover"
                    color="inherit"
                    href={`tel:+${CONTACT.phone}`}
                    sx={{ fontWeight: 800 }}
                  >
                    اتصال: +{CONTACT.phone}
                  </Link>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <EmailRoundedIcon />
                  <Link
                    underline="hover"
                    color="inherit"
                    href={`mailto:${CONTACT.email}`}
                    sx={{ fontWeight: 800, direction: "ltr" }}
                  >
                    {CONTACT.email}
                  </Link>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <LocationOnRoundedIcon />
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    خميس مشيط — تغطية المنطقة الجنوبية كاملة
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <LocationOnRoundedIcon />
                  <Typography variant="body2" sx={{ opacity: 0.9 }}>
                    جدة - خالد بن الوليد
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>

          <Divider
            sx={{ my: { xs: 3, md: 4 }, borderColor: "rgba(255,255,255,.18)" }}
          />

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            flexWrap="wrap"
            useFlexGap
            spacing={1.5}
            sx={{ opacity: 0.95 }}
          >
            <Typography variant="caption">
              © {year} {BRAND.name} — جميع الحقوق محفوظة
            </Typography>
            {/* <Stack direction="row" spacing={2} alignItems="center">
              <Link
                component="button"
                color="inherit"
                underline="hover"
                onClick={() => scrollToId("faq")}
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
              >
                <PolicyRoundedIcon fontSize="small" /> سياسة الخصوصية
              </Link>
              <Link
                component="button"
                color="inherit"
                underline="hover"
                onClick={() => scrollToId("faq")}
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
              >
                <SecurityRoundedIcon fontSize="small" /> الشروط والأحكام
              </Link>
            </Stack> */}
          </Stack>
        </Container>
      </Box>
    </Box>
  );
}
